import { PaginationReduxActions } from './Action';

export interface IPagination {
  offset: number;
  pageLimit: number;
  totalRecords: number;
  totalPages: number;
}

export interface IDataset extends IPagination {
  search: string;
  status: string;
}

export interface IAISystem extends IPagination {
  search: string;
  status: string;
}

export interface IPolicy extends IPagination {
  search: string;
  tab: string;
}

export interface IEmployeeTablePagination extends IPagination {
  search: string;
}

export interface ITeamsPagination extends IPagination {
  search: string;
}

export interface IInvitationPagination extends IPagination {
  search: string;
}

export interface IVulnerabilitiesPagination extends IPagination {
  search: string;
  status: string;
  risk: string;
}

export interface IRiskAssesmentPagination extends IPagination {
  search: string;
}

export interface IAssessmentPagination extends IPagination {
  search: string;
  // assessmentType: string;
  sort: string;
  enitityType: string;
  status: string;
  templateId: string;
}

export interface IMCPServerPagination extends IPagination {
  search: string;
  status: string;
}

export interface IRisksPagination extends IPagination {
  search: string;
  status: string;
}

export interface IIncidentsPagination extends IPagination {
  search: string;
  status: string;
  severity: string;
}

export interface IProgramsPagination extends IPagination {
  search: string;
  status: string;
  domain: string;
}

export interface IRiskTierPagination extends IPagination {
  search: string;
  status: string;
}

export interface PaginationState {
  dataset: IDataset;
  aISystem: IAISystem;
  policy: IPolicy;
  employeeTable: IEmployeeTablePagination;
  teams: ITeamsPagination;
  all_invitation: IInvitationPagination;
  vulnerabilities: IVulnerabilitiesPagination;
  assessment: IAssessmentPagination;
  mcpServer: IMCPServerPagination;
  risks: IRisksPagination;
  incidents: IIncidentsPagination;
  programs: IProgramsPagination;
  riskTier: IRiskTierPagination;
  riskAssessment: IRiskAssesmentPagination;
}
export const DefaultPaginationState = {
  dataset: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    status: '',
  },

  aISystem: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    status: '',
  },

  policy: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    tab: 'All Policies',
  },

  employeeTable: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
  },

  teams: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
  },

  all_invitation: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
  },

  vulnerabilities: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    status: '',
    risk: '',
  },

  assessment: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    // assessmentType: 'self',
    sort: 'asc',
    enitityType: '',
    status: '',
    templateId: '',
  },

  mcpServer: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    status: '',
  },

  risks: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    status: '',
  },

  incidents: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    status: '',
    severity: '',
  },

  programs: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    status: '',
    domain: '',
  },

  riskTier: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
    status: '',
  },
  riskAssessment: {
    offset: 0,
    pageLimit: 10,
    totalRecords: 0,
    totalPages: 0,
    search: '',
  },
};
const paginationState: PaginationState = { ...DefaultPaginationState };

const PaginationReducer = (
  state: PaginationState = paginationState,
  action: any
): PaginationState => {
  switch (action.type) {
    case PaginationReduxActions.UPDATE_PAGINATION:
      return {
        ...state,

        ...Object.keys(action.payload).reduce(
          (acc, key) => ({
            ...acc,

            [key]: {
              ...state[key as keyof PaginationState],
              ...action.payload[key],
            },
          }),
          {}
        ),
      };

    default:
      return state;
  }
};

export default PaginationReducer;
